import DatePickerMode from '../../types/DatePickerMode';

const supportsBothMultiAndSingleDay = (subject: DatePickerMode): boolean => {
    return subject === 'PrimarilyMultiDay' || subject === 'PrimarilySingleDay';
};

export default supportsBothMultiAndSingleDay;
